import React from "react";
import {Layout} from "antd";
import Utils from "../../commons/utils/utils";

const year = Utils.getCurrentYear();
const {Footer} = Layout;


export default props => {
    return (
        <Footer>
            <div style={{ minHeight: "82px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <span>Copyright © {year} - Sankhya Gestão de Negócios. Todos os direitos reservados.</span>
            </div>
        </Footer>
    )
}
